export default {
  AlarmEvent: 'Alert event',
  EventName: 'Event name',
  AlarmTime: 'Alert time',
  EventType: 'Event type',
  Importance: 'Importance',
  Branch: 'Branch',
  RelationGateway: 'Associate gateway',
  RelationCpe: 'Associate device',
  SearchPlaceholder: 'Search for device id / device name / gateway id / branch / event content', 
  AlarmConfig: 'Alert settings',
  MessageSubscribe: 'Message subscribe',
  Low: 'Low',
  High: 'High',
  AlarmSwitch: 'Alert switch',
  MonitoringGateway: 'Monitor gateways',
  AlarmValue: 'Alert value',
  AlarmCondition: 'Alert condition',
  AddReceiver: 'Add receiver',
  EditReceiver: 'Edit receiver',
  SubscribeTips: 'The alert switch is turned off by default, and you can configure it yourself as needed. It is recommended to keep alerts on for high importance events to keep track of your services.',
  SubscribeSwitch: 'Subscription Switch',
  Receiver: 'Receiver',
  ReceiveMode: 'Receive mode',
  ReceivePhone: 'Phone number',
  ReceiveEmail: 'Email',
  InputPositiveInteger: 'Fill in the positive integer',
  Frequency: 'times',
  AllGateways: 'All gateways',
  PartialGateway: 'Partial gateways',
  SearchGatewayName: 'Search by gateway name',
  AlarmValuePlaceholder: 'Fill in 1-100',
  Number: 'number',
  CpeStatusChangeToOnline: 'Device status changed to online',
  CpeStatusChangeToOffline: 'Device status changed to offine',
  UnableConnect: 'The full link of the device cannot be connected',
  CurrentFlowLinkSwitched: 'The current traffic forwarding link has switched',
  AlarmConditionsTip: 'Trigger alarm conditions: The alarm will be triggered when the number of times the alarm value is continuously exceeded reaches the set number',
  AlarmConditionsPlaceholder: 'Please select the alert condition',
  AlarmEventTip: 'Low: The current alarm event does not affect business and performance\n Mid: The current alarm event may affect business and performance\n High: The current alarm event will affect business and performance, etc.',
  ReceiverName: 'Receiver name',
  PhonePlaceholder: 'Fill in the cell phone number that needs to receive alarm notifications',
  EmailPlaceholder: 'Fill in the cell phone number that needs to receive alarm notifications',
  ReceiverModeRequire: 'Please check the receiving method and fill in the contact information of the recipient',
  ReceiverDetailInfoRequire: 'Please fill in the receiving method details',
  InfoDeleteConfirm: 'Sure to delete the current recipient?',
  InfoDeleteTip: 'Can not be restored after deletion, can be added again if needed',
  Duration: 'Duration',
  AlarmStatu: 'Alert status',
  AddReceiverSuccess: 'Add new recipient success',
  AlarmValueRequire: 'Please fill in the alert threshold',
  isNotRequired: (title: string) => `There is an error in the format, please enter the valid${title}`,
  EventContent: 'Event Content',
}